var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.97 5.67c0 11.5-6.5 23.5-27.5 23.5",
    stroke: "#27A83B",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.73 32.92L.47 29.67c-.43-.43-.4-1.16.06-1.64l3.25-2.57c.76-.76 1.98-.33 1.95.7v5.82c-.04 1.05-1.3 1.63-2 .94z",
    fill: "#27A83B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointArrow);
export default __webpack_public_path__ + "static/media/point-arrow.14c6d6b9640a841404e4335231235ac2.svg";
export { ForwardRef as ReactComponent };